import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const holdPickItemRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/picks/:id/items/:itemId/hold',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/picks/:id/items/:itemId/hold' \\
--header 'Authorization: Bearer <TOKEN>' \\
--header 'Content-Type: application/json'
`,
};

const holdPickItemResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 129,
        'number': 'S10074',
        'status': 'Started',
        'type': 'Pick',
        'priority': '3-Normal',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'username': 'admin',
        'dateCreated': '2026-04-03T04:19:58.933+00:00',
        'dateScheduled': '2026-01-07T13:54:21.000+00:00',
        'dateStarted': '2026-04-03T04:31:12.118+00:00',
        'dateLastModified': '2026-04-03T04:38:47.512+00:00',
        'toBePrinted': false,
        'pickItems': [
            {
                'id': 547,
                'part': {
                    'id': 79,
                    'name': 'B203',
                    'description': 'Basic Brake Cables'
                },
                'status': 'Hold',
                'type': 'Normal',
                'quantity': '8',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 156
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            },
            {
                'id': 549,
                'part': {
                    'id': 12,
                    'name': 'AC-01',
                    'description': 'Aluminum Casing'
                },
                'status': 'Started',
                'type': 'Normal',
                'quantity': '3',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 2,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 158
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceLocation': {
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            }
        ],
        'customFields': []
    },
};

const data: RequestDefinitionData = {
    id: 'hold-pick-item',
    title: 'Hold a pick item',
    description: 'Puts a single pick item on hold. The item is moved to "Hold" and its source location, tag, and tracking are cleared, which releases that inventory back to the pick\'s other items. '
        + 'Returns the full pick object, the same shape as "Get a pick" — note that the response reflects the whole pick, not just the item that was held. '
        + 'In the example response item 547 was held and its assignment was cleared. '
        + 'An item in "Short", "Entered", or "Started" status can be held; "Committed" and "Finished" return a 400 error naming the item\'s current status. '
        + 'Holding an item that is already on hold succeeds and leaves it on hold — it does not release it. Use "Unhold a pick item" to release it. '
        + 'The remaining items are re-evaluated against available inventory afterwards, so holding an item can make another item on the pick sourceable, and the pick\'s own status is recalculated from its items. '
        + 'Because that pass can merge mergeable lines, the pick item IDs in the response are not guaranteed to match those from an earlier "Get a pick" call. '
        + 'A "BTO" item is never sourced from inventory: its source location, tag, and tracking are cleared, but it does not take the "Hold" status and comes back "Short". '
        + 'Requires PICK_EDIT access right. Validates location group access — returns 403 if the user does not have access to the pick\'s location group. '
        + 'Returns 404 if the pick or the pick item is not found, and an error if the pick item does not belong to the pick in the URL.',
    endpoint: {
        verb: 'POST',
        path: '/picks/:id/items/:itemId/hold',
        tooltip: 'Hold a pick item',
    },
    attributes: [],
    requestObject: holdPickItemRequest,
    responseObject: holdPickItemResponse,
};

export default data;
